export const roles = {
  superAdmin: 'Admin',
  clientAdmin: 'ClientAdmin',
  clientUser: 'ClientUser',
  schoolAdmin: 'School Administrator',
  schoolUser: 'School User'
}
